import { BaseRequest } from "planning-portal-library/src/lib/data/shared/base.request";
import { GetLocationsRequest, LocationUpdateNotification } from "../../domain";
import { UseCase } from "../../base";
import { LocationsRepository } from "../../repositories";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class GetLocationsUpdateNotificationUsecae implements UseCase<any | undefined, LocationUpdateNotification[]> {

  constructor(private readonly locationUpdateNotificationRepository: LocationsRepository) {
  }

  execute(params?: any | undefined): Observable<LocationUpdateNotification[]> {
    return this.locationUpdateNotificationRepository.getLocationUpdatesNotification(params);
  }

}